import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import UserService from '../Services/UserService';
import {extractErrorMessage} from '../Services/RequestService';
import {replaceInCollection} from './utils';
import { userTypes } from "../CommonConstants";

export const useUsers = () => {
    const [users, setUsers] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            let resp = await UserService.allUsers(token);
            let admins = resp.data.filter((user) => {
                return user.type !== userTypes.admin.type
            });
            setUsers(admins);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addUser = async (user) => {
        try {
            let resp = await UserService.addUser(user, token);
            const userFormated = {
                ...user,
                active: true
            }
            delete userFormated.password
            setUsers([...users, {...userFormated, id: resp.data.id}]);
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateUser = async (user) => {
        try {
            await UserService.updateUser(user, token);
            setUsers(replaceInCollection(user, users));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const disableUser = async (user) => {
        try {
            await UserService.disableUser(user.id, token);
            user.active = false;
            setUsers(replaceInCollection(user, users));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const enableUser = async (user) => {
        try {
            await UserService.enableUser(user.id, token);
            user.active = true;
            setUsers(replaceInCollection(user, users));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [users, addUser, updateUser, disableUser, enableUser];
}


// WEBPACK FOOTER //
// ./src/Hooks/useUsers.js